import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";

import { appConfig } from './app.config';
import { AppComponent } from './app.component';

Sentry.init({
    dsn: "https://53c2bc09aa5f7c8d9d9948f683539310@o300968.ingest.us.sentry.io/4510120450064384",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
});
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
